import { Component, Vue } from 'types-vue'

@Component
export default class BillConcepts extends Vue {}